import { render, staticRenderFns } from "./p-r-upload.vue?vue&type=template&id=27aeab02&scoped=true"
import script from "./p-r-upload.vue?vue&type=script&lang=js"
export * from "./p-r-upload.vue?vue&type=script&lang=js"
import style0 from "./p-r-upload.vue?vue&type=style&index=0&id=27aeab02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aeab02",
  null
  
)

export default component.exports